import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import GalleryModal from './ImageUploadModal'; // new modal
import { toast } from "react-toastify"; // ✅ Only toast is needed


const GalleryTable = () => {
    const { isSidebarOpen } = useSidebar();
    const [gallery, setGallery] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredGallery, setFilteredGallery] = useState(gallery);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

//  { image: 'https://via.placeholder.com/100' },
//         { image: 'https://via.placeholder.com/100' },
//         { image: 'https://via.placeholder.com/100' },


        const BASE_URL = process.env.REACT_APP_API_BASE_URL;

    
    useEffect(() => {
        const filtered = gallery.filter((item) =>
            item.image?.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredGallery(filtered);
        setCurrentPage(1);
    }, [searchQuery, gallery]);



    useEffect(() => {
    fetchGallery();
}, []);

const fetchGallery = async () => {
    try {
        const res = await fetch(`${BASE_URL}/api/gallery`);
        const data = await res.json();
        setGallery(data);
    } catch (err) {
        console.error('Error fetching gallery:', err);
    }
};


    const totalPages = Math.ceil(filteredGallery.length / itemsPerPage);
    const currentData = filteredGallery.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

  const handleDelete = async (id) => {
      const confirmDelete = window.confirm("Are you sure you want to delete this image?");
    if (!confirmDelete) return;
    try {
        await fetch(`${BASE_URL}/api/gallery/${id}`, { method: 'DELETE' });
                toast.success("Image deleted successfully!");

        fetchGallery(); // reload from server
    } catch (err) {
        console.error('Error deleting image:', err);
                toast.error("Failed to delete image!");

    }
};

    const openModal = (item = null) => {
        setSelectedImage(item);
        setIsModalOpen(true);
    };

  const handleSave = async (newImageFile) => {
    const formData = new FormData();
    formData.append('image', newImageFile);

    try {
        if (selectedImage && selectedImage.id) {
            // PUT for update
            await fetch(`${BASE_URL}/api/gallery/${selectedImage.id}`, {
                method: 'PUT',
                body: formData,
            });
                        toast.success("Image updated successfully!");

        } else {
            // POST for new
            await fetch(`${BASE_URL}/api/gallery`, {
                method: 'POST',
                body: formData,
            });
                        toast.success("Image updated successfully!");

        }

        fetchGallery();
        setIsModalOpen(false);
        setSelectedImage(null);
    } catch (err) {
        console.error('Error saving image:', err);
                toast.error("Failed to save image!");

    }
};

    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Gallery</h1>
                    <button className="oms-add-btn" onClick={() => openModal()}>
                        Add Image
                    </button>
                </div>

                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search image URL..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th style={{ minWidth: '120px' }}>Image</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <img
                                                src={item.image}
                                                alt="Gallery"
                                                style={{ width: '80px', borderRadius: '8px' }}
                                            />
                                        </td>
                                        <td>
                                            <button className="edit-button" onClick={() => openModal(item)}>
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            <button className="delete-button" onClick={() => handleDelete(item.id)}>
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2" style={{ textAlign: 'center' }}>
                                        No images found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => setCurrentPage(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}>
                        Next
                    </button>
                </div>
            </div>

            <GalleryModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                onSave={handleSave}
                initialImage={selectedImage?.image || ''}
            />
        </>
    );
};

export default GalleryTable;
